import { useEffect, useRef } from 'react';
import { useApp } from './AppContext';

export function PasswordRecoveryHandler() {
  const { navigateTo } = useApp();
  const hasHandled = useRef(false);

  useEffect(() => {
    const handleRecovery = () => {
      if (hasHandled.current) return;

      const hash = window.location.hash;
      const search = window.location.search;
      const fullUrl = window.location.href;

      console.log('[PasswordRecoveryHandler] Checking for recovery tokens');
      console.log('[PasswordRecoveryHandler] Hash:', hash);
      console.log('[PasswordRecoveryHandler] Search:', search);
      console.log('[PasswordRecoveryHandler] Full URL:', fullUrl);

      // Check for recovery tokens in BOTH hash (#) and query string (?)
      // Supabase can send tokens in different formats:
      // Format 1: #access_token=xxx&type=recovery (hash fragment)
      // Format 2: #/reset-password?access_token=xxx&type=recovery (hash route with query)
      // Format 3: ?access_token=xxx&type=recovery#/reset-password (query string with hash route)
      // Format 4: ?access_token=xxx&type=recovery (just query string)
      // Format 5: #/reset-password#access_token=xxx (double hash - Supabase bug)

      let queryString = '';
      let hasTokens = false;

      // First check hash fragment
      if (hash && hash.includes('access_token')) {
        const hashContent = hash.substring(1); // Remove leading #

        // Check for double hash format: #/reset-password#access_token=xxx
        if (hashContent.includes('#')) {
          const parts = hashContent.split('#');
          // Second part contains the tokens
          queryString = parts[1] || '';
          console.log('[PasswordRecoveryHandler] Double hash detected, extracted:', queryString);
        } else if (hashContent.includes('?')) {
          queryString = hashContent.split('?')[1];
        } else if (hashContent.includes('&')) {
          queryString = hashContent;
        } else if (hashContent.startsWith('access_token')) {
          queryString = hashContent;
        }
        hasTokens = true;
      }

      // If no tokens in hash, check query string
      if (!hasTokens && search && search.includes('access_token')) {
        queryString = search.substring(1); // Remove leading ?
        hasTokens = true;
      }

      if (!hasTokens) return;

      const params = new URLSearchParams(queryString);
      const type = params.get('type');
      const accessToken = params.get('access_token');

      console.log('[PasswordRecoveryHandler] Parsed - type:', type, 'has access_token:', !!accessToken);

      // If this is a recovery link, ensure we're on the reset-password screen
      if (type === 'recovery' && accessToken) {
        hasHandled.current = true;
        console.log('[PasswordRecoveryHandler] 🔐 RECOVERY DETECTED - Redirecting to reset-password screen');

        // Reconstruct the hash with the proper route using ? separator
        const newHash = `#/reset-password?${queryString}`;

        // Always update to clean format (fixes double hash issue)
        console.log('[PasswordRecoveryHandler] Updating hash to:', newHash);
        window.location.hash = newHash;
        // The AppContext will pick this up and navigate

        return;
      }
    };

    // Check on mount
    handleRecovery();

    // Also check when hash changes
    const handleHashChange = () => {
      hasHandled.current = false; // Reset so we can handle new hash
      handleRecovery();
    };

    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [navigateTo]);

  return null;
}
